import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { CompraService } from '../compra.service';

@Component({
  selector: 'app-compra-update',
  templateUrl: './compra-update.component.html',
  styleUrls: ['./compra-update.component.scss']
})
export class CompraUpdateComponent implements OnInit {
  @Input() element: any = {}
  compra: FormGroup = new FormGroup({});
  total: number = 0;
  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public formatter: FormatterService,
    public service: CompraService
  ) { }

  ngOnInit(): void {
    this.compra = this.formBuilder.group({
      id: [],
      fecha: [],
      detalles: [],
      monto: [],
      iva: [0],
      estado: [],
      sucursal_id: [],
    });
    this.element.fecha = this.element.fecha.substring(0, 10);
    this.compra.patchValue(this.element);
    this.compra.disable();
    this.calcularTotal();
  }

  actualizarLinea(e: any, index: number): void {
    this.element.lineas[index].cantidad = Number(e.target.value);
    this.element.lineas[index].precio_linea = this.element.lineas[index].cantidad * this.element.lineas[index].precio_unitario;
    this.calcularTotal();
  }

  calcularTotal(): void {
    this.total = 0
    this.element.lineas.forEach((element: any) => {
      this.total += element.precio_linea
      this.compra.controls['monto'].setValue(this.total)
    });
  }

  modificar(): void {
    this.service.update(this.element.lineas, this.compra.value).subscribe({
      next: (res) => {
        this.loading.hide();
        this.activeModal.close(res.model);
        this.alerts.addAlert(res.response, "success");
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo guardar el registro.", "danger");
        if (err.error.response) {
          this.alerts.addAlert(err.error.response, "danger");
        }
      }
    });
  }
}
